if (!customElements.get('collapsible-text')) {
  customElements.define(
    'collapsible-text',
    class CollapsibleText extends HTMLElement {
      constructor() {
        super();
        this.target = this.querySelector('[data-collapsed-text]');
        this.targetInner = this.target.querySelector('[data-collapsed-text-inner]')
        this.trigger = this.querySelector('[data-collapsed-text-trigger]');
      }

      connectedCallback() {
        this.trigger.addEventListener('click', this.toggleTarget.bind(this));
      }

      toggleTarget() {
        this.target.hasAttribute('open') ? this.hideTarget() : this.revealTarget();
      }

      hideTarget() {
        this.target.removeAttribute('open');
        this.target.style.height = 0;
        this.trigger.textContent = 'View more';
      }

      revealTarget() {
        this.target.setAttribute('open', '');
        this.target.style.height = `${this.targetInner.offsetHeight}px`;
        this.trigger.textContent = 'View less';
      }
    }
  );
}
